import {ref} from 'vue';

export default {
    install: (app, options) => {
        const fileRequestStatuses = ref([]);
        const fileRequestStatus = ref(null);

        const loadFileRequestStatuses = (reset = false) => {
            if (reset) {
                fileRequestStatuses.value = [];
            }

            window.lazy_axios.get(`/file-requests/statuses`)
                .then((response) => {
                    if (response.data.statuses) {
                        fileRequestStatuses.value = response.data.statuses;
                        fileRequestStatus.value = response.data.file_request_status;
                    }
                });
        };

        app.provide('fileRequestStatuses', fileRequestStatuses);
        app.provide('fileRequestStatus', fileRequestStatus);
        app.provide('loadFileRequestStatuses', loadFileRequestStatuses);
    },
}
